"use client"

import { getHrefWithThreadPreservation, BRIEFS_CREATE_HREF } from '@yeshuman/sdk'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/** Legacy route — redirects to briefs list with create canvas. */
export function BriefCreatePage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(getHrefWithThreadPreservation(BRIEFS_CREATE_HREF), { replace: true })
  }, [navigate])

  return null
}
